import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import './index.css'
@observer
class VestWindow extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: "",
        }
    }

    submit = (val) => {
        if (val && this.state.value !== '') {
            let data = { type: val, value: this.state.value }
            this.props.submit(data)
        } else {
            let data = { type: val, value: '' }
            this.props.submit(data)
        }
    }

    changeValue = (e) => {
        let value = e.target.value
        this.setState({ value: value })
    }

    render() {
        return (
            <div className='vest_w'>
                <div className='vest_c'>
                    <div className='vest_ctp'>
                        <textarea placeholder={this.props.placeholder} value={this.state.value} onChange={(e) => { this.changeValue(e) }}></textarea>
                    </div>
                    <div className='vest_cbtm'>
                        <span onClick={() => { this.submit(false) }}>取消</span>
                        <span onClick={() => { this.submit(true) }}>确定</span>
                    </div>
                </div>
            </div >
        )
    }
}
export default withRouter(VestWindow)